import './Toast.scss';
import { NotificationItem } from '@components/Component/NotificationItem/NotificationItem.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { sanitizeHTML } from "@components/Utility/index.js";
/**
 * `Toast` component.
 */
export class Toast extends NotificationItem {
    get style() { return this._style; }
    set style(s) {
        this._propertySet('style', s);
        this.renderStyle();
    }
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'Toast';
        this._style = 'info';
    }
    draw() {
        super.draw();
        this.rootElement.classList.add('s360NotificationItem');
        this.renderStyle();
    }
    renderMessage() {
        if (this.drawn) {
            this.rootElement.querySelector('.notification-message').innerHTML = sanitizeHTML(this.message);
        }
    }
    renderStyle() {
        if (this.drawn) {
            this.rootElement.classList.remove('style--success', 'style--info', 'style--warning', 'style--error');
            this.rootElement.classList.add(`style--${this._style ?? 'info'}`);
        }
    }
    calculateElapsed(refreshDom = false) {
        // no timestamp on toasts
        //super.calculateElapsed(refreshDom);
    }
    dismiss(clearAll = false) {
        DIContainer.getInstance('ToastManager').dismiss(this.id, 'click');
    }
}
Toast.VERSION = '$Revision: 112048 $';
